import { AppData } from '../models/appdata'
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import { Observable } from 'rxjs/Observable';
import { Observable, throwError, observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
//import 'rxjs/add/operator/retry';
import { Router } from '@angular/router';
import { ApiResponseModel } from '../models/api_response_model';
import { ApiRequestModel } from '../models/api_request_model';
import { CodeTypeRequest } from '../custumcomponents/codetypes/codetypevalue.interface';
import { CredentialTypeRequest, ActorRoleDutyRequest, ActorCredentialConfigRequest, RolesRequest, ModulesRequest, RoleFeatureLinkRequest, TimeZoneMasterRequest } from '../models/master/mastermodel';



@Injectable()
export class MasterService {


  constructor(private http: HttpClient, private router: Router) {


  }

  GetCodeTypesController(SendCodeTypeRequest: CodeTypeRequest) {


    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetCodeTypes`, (SendCodeTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  //////////////////////////
  SaveCodeTypeValues(SendCodeTypeRequest: CodeTypeRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/SaveCodeTypeValues`, (SendCodeTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  GetCredentialTypeController(SendCredentialTypeRequest: CredentialTypeRequest) {


    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetCredentialTypeInfo`, (SendCredentialTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //////////////////////////
  SaveCredentialTypeInfo(SendCredentialTypeRequest: CredentialTypeRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/SaveCredentialTypeInfo`, (SendCredentialTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorRoleDutyController(SendActorRoleDutyRequest: ActorRoleDutyRequest) {


    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetActorRoleDutyInfo`, (SendActorRoleDutyRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //////////////////////////
  SaveActorRoleDutyInfo(SendActorRoleDutyRequest: ActorRoleDutyRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/SaveActorRoleDutyInfo`, (SendActorRoleDutyRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  GetActorCredentialConfigController(SendActorCredentialConfigRequest: ActorCredentialConfigRequest) {


    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetActorCredentialConfigInfo`, (SendActorCredentialConfigRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //////////////////////////
  SaveActorCredentialConfigInfo(SendActorCredentialConfigRequest: ActorCredentialConfigRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/SaveActorCredentialConfigInfo`, (SendActorCredentialConfigRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  //
  GetModulesInfoController(SendModulesRequest: ModulesRequest) {


    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetModulesInfo`, (SendModulesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  GetRolesInfoController(SendRolesRequest: RolesRequest) {


    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetRolesInfo`, (SendRolesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //
  GetRoleFeatureLinkInfoController(SendRoleFeatureLinkRequest: RoleFeatureLinkRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetRoleFeatureLinkInfo`, (SendRoleFeatureLinkRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //////////////////////////
  SaveRoleFeatureLinkInfo(SendRoleFeatureLinkRequest: RoleFeatureLinkRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/SaveRoleFeatureLinkInfo`, (SendRoleFeatureLinkRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //

  GetTimeZoneMasterController(SendTimeZoneMasterRequest: TimeZoneMasterRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetTimeZoneMasterInfo`, (SendTimeZoneMasterRequest),
      {
        //headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //


  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    //else if (error.status === 401) {
    //  return this.unauthorised();
    //  //return Promise.reject('UnAuthorised Request..!');

    //}
    else if (error.status === 401) {

      //  this.router.navigate(['login']);;;
      //return this.unauthorised();
      return Promise.reject('401 - Unauthorized');

    }
    else if (error.status === -1212401) {

      //  this.router.navigate(['login']);;;
      return this.unauthorised();
      //return Promise.reject('UnAuthorised Request..!');

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else if (error.status === 415) {

      return Promise.reject('Request Failed Due to Unsupported Media Type..!');
    }
    else if (error.status === 404) {
      return Promise.reject('Page Not Found..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['signinpage']);
    return throwError(() => ({}));
  }

}
